import { useEffect, useState } from "react";

type Props = {
  isVisible: boolean;
};

const useManageSearchButton = ({ isVisible }: Props) => {
  const [show, setShow] = useState(isVisible);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => setShow(true), 500);
    } else setShow(isVisible);
  }, [isVisible]);

  return {
    show,
  };
};

export default useManageSearchButton;
